export default [
    {
        lat: 50.07,
        lng: 8.97,
    },
    {
        lat: 50.085,
        lng: 8.98,
    },
    {
        lat: 50.105,
        lng: 8.98,
    },
    {
        lat: 50.13,
        lng: 9.01,
    },
    {
        lat: 50.14,
        lng: 9.065,
    },
    {
        lat: 50.135,
        lng: 9.08,
    },
    {
        lat: 50.145,
        lng: 9.09,
    },
    {
        lat: 50.145,
        lng: 9.13,
    },
    {
        lat: 50.135,
        lng: 9.145,
    },
    {
        lat: 50.14,
        lng: 9.15,
    },
    {
        lat: 50.135,
        lng: 9.165,
    },
    {
        lat: 50.155,
        lng: 9.17,
    },
    {
        lat: 50.17,
        lng: 9.215,
    },
    {
        lat: 50.16,
        lng: 9.25,
    },
    {
        lat: 50.165,
        lng: 9.28,
    },
    {
        lat: 50.155,
        lng: 9.305,
    },
    {
        lat: 50.16,
        lng: 9.34,
    },
    {
        lat: 50.15,
        lng: 9.35,
    },
    {
        lat: 50.15,
        lng: 9.385,
    },
    {
        lat: 50.105,
        lng: 9.415,
    },
    {
        lat: 50.115,
        lng: 9.495,
    },
    {
        lat: 50.145,
        lng: 9.485,
    },
    {
        lat: 50.16,
        lng: 9.49,
    },
    {
        lat: 50.165,
        lng: 9.48,
    },
    {
        lat: 50.21,
        lng: 9.485,
    },
    {
        lat: 50.22,
        lng: 9.475,
    },
    {
        lat: 50.25,
        lng: 9.48,
    },
    {
        lat: 50.265,
        lng: 9.495,
    },
    {
        lat: 50.25,
        lng: 9.545,
    },
    {
        lat: 50.255,
        lng: 9.575,
    },
    {
        lat: 50.245,
        lng: 9.59,
    },
    {
        lat: 50.245,
        lng: 9.615,
    },
    {
        lat: 50.265,
        lng: 9.62,
    },
    {
        lat: 50.29,
        lng: 9.645,
    },
    {
        lat: 50.3,
        lng: 9.695,
    },
    {
        lat: 50.31,
        lng: 9.7,
    },
    {
        lat: 50.32,
        lng: 9.725,
    },
    {
        lat: 50.335,
        lng: 9.725,
    },
    {
        lat: 50.34,
        lng: 9.715,
    },
    {
        lat: 50.365,
        lng: 9.715,
    },
    {
        lat: 50.39,
        lng: 9.735,
    },
    {
        lat: 50.42,
        lng: 9.73,
    },
    {
        lat: 50.445,
        lng: 9.75,
    },
    {
        lat: 50.445,
        lng: 9.81,
    },
    {
        lat: 50.425,
        lng: 9.83,
    },
    {
        lat: 50.42,
        lng: 9.85,
    },
    {
        lat: 50.43,
        lng: 9.865,
    },
    {
        lat: 50.425,
        lng: 9.9,
    },
    {
        lat: 50.445,
        lng: 9.95,
    },
    {
        lat: 50.495,
        lng: 10.015,
    },
    {
        lat: 50.525,
        lng: 10.02,
    },
    {
        lat: 50.535,
        lng: 10.03,
    },
    {
        lat: 50.535,
        lng: 10.045,
    },
    {
        lat: 50.56,
        lng: 10.065,
    },
    {
        lat: 50.56,
        lng: 10.075,
    },
    {
        lat: 50.585,
        lng: 10.1,
    },
    {
        lat: 50.585,
        lng: 10.125,
    },
    {
        lat: 50.57,
        lng: 10.145,
    },
    {
        lat: 50.575,
        lng: 10.21,
    },
    {
        lat: 50.55,
        lng: 10.235,
    },
    {
        lat: 50.55,
        lng: 10.245,
    },
    {
        lat: 50.535,
        lng: 10.25,
    },
    {
        lat: 50.525,
        lng: 10.27,
    },
    {
        lat: 50.51,
        lng: 10.345,
    },
    {
        lat: 50.495,
        lng: 10.36,
    },
    {
        lat: 50.475,
        lng: 10.36,
    },
    {
        lat: 50.46,
        lng: 10.375,
    },
    {
        lat: 50.46,
        lng: 10.39,
    },
    {
        lat: 50.445,
        lng: 10.4,
    },
    {
        lat: 50.445,
        lng: 10.415,
    },
    {
        lat: 50.42,
        lng: 10.425,
    },
    {
        lat: 50.425,
        lng: 10.455,
    },
    {
        lat: 50.415,
        lng: 10.47,
    },
    {
        lat: 50.395,
        lng: 10.48,
    },
    {
        lat: 50.395,
        lng: 10.5,
    },
    {
        lat: 50.38,
        lng: 10.51,
    },
    {
        lat: 50.385,
        lng: 10.55,
    },
    {
        lat: 50.365,
        lng: 10.575,
    },
    {
        lat: 50.355,
        lng: 10.575,
    },
    {
        lat: 50.35,
        lng: 10.615,
    },
    {
        lat: 50.345,
        lng: 10.62,
    },
    {
        lat: 50.31,
        lng: 10.615,
    },
    {
        lat: 50.305,
        lng: 10.625,
    },
    {
        lat: 50.245,
        lng: 10.63,
    },
    {
        lat: 50.25,
        lng: 10.67,
    },
    {
        lat: 50.245,
        lng: 10.695,
    },
    {
        lat: 50.235,
        lng: 10.705,
    },
    {
        lat: 50.25,
        lng: 10.705,
    },
    {
        lat: 50.27,
        lng: 10.72,
    },
    {
        lat: 50.27,
        lng: 10.75,
    },
    {
        lat: 50.26,
        lng: 10.765,
    },
    {
        lat: 50.275,
        lng: 10.785,
    },
    {
        lat: 50.275,
        lng: 10.76,
    },
    {
        lat: 50.295,
        lng: 10.74,
    },
    {
        lat: 50.305,
        lng: 10.7,
    },
    {
        lat: 50.355,
        lng: 10.69,
    },
    {
        lat: 50.37,
        lng: 10.695,
    },
    {
        lat: 50.385,
        lng: 10.71,
    },
    {
        lat: 50.38,
        lng: 10.745,
    },
    {
        lat: 50.39,
        lng: 10.765,
    },
    {
        lat: 50.405,
        lng: 10.775,
    },
    {
        lat: 50.4,
        lng: 10.8,
    },
    {
        lat: 50.415,
        lng: 10.83,
    },
    {
        lat: 50.415,
        lng: 10.89,
    },
    {
        lat: 50.405,
        lng: 10.9,
    },
    {
        lat: 50.415,
        lng: 10.935,
    },
    {
        lat: 50.395,
        lng: 10.975,
    },
    {
        lat: 50.38,
        lng: 10.98,
    },
    {
        lat: 50.385,
        lng: 11.02,
    },
    {
        lat: 50.38,
        lng: 11.045,
    },
    {
        lat: 50.37,
        lng: 11.05,
    },
    {
        lat: 50.37,
        lng: 11.065,
    },
    {
        lat: 50.385,
        lng: 11.08,
    },
    {
        lat: 50.39,
        lng: 11.1,
    },
    {
        lat: 50.385,
        lng: 11.125,
    },
    {
        lat: 50.345,
        lng: 11.175,
    },
    {
        lat: 50.32,
        lng: 11.18,
    },
    {
        lat: 50.305,
        lng: 11.17,
    },
    {
        lat: 50.31,
        lng: 11.21,
    },
    {
        lat: 50.3,
        lng: 11.23,
    },
    {
        lat: 50.315,
        lng: 11.24,
    },
    {
        lat: 50.315,
        lng: 11.235,
    },
    {
        lat: 50.345,
        lng: 11.245,
    },
    {
        lat: 50.355,
        lng: 11.24,
    },
    {
        lat: 50.37,
        lng: 11.255,
    },
    {
        lat: 50.39,
        lng: 11.24,
    },
    {
        lat: 50.43,
        lng: 11.245,
    },
    {
        lat: 50.43,
        lng: 11.235,
    },
    {
        lat: 50.445,
        lng: 11.225,
    },
    {
        lat: 50.49,
        lng: 11.23,
    },
    {
        lat: 50.5,
        lng: 11.24,
    },
    {
        lat: 50.505,
        lng: 11.295,
    },
    {
        lat: 50.53,
        lng: 11.315,
    },
    {
        lat: 50.53,
        lng: 11.33,
    },
    {
        lat: 50.54,
        lng: 11.34,
    },
    {
        lat: 50.545,
        lng: 11.375,
    },
    {
        lat: 50.535,
        lng: 11.435,
    },
    {
        lat: 50.51,
        lng: 11.46,
    },
    {
        lat: 50.48,
        lng: 11.455,
    },
    {
        lat: 50.475,
        lng: 11.44,
    },
    {
        lat: 50.46,
        lng: 11.445,
    },
    {
        lat: 50.45,
        lng: 11.455,
    },
    {
        lat: 50.45,
        lng: 11.495,
    },
    {
        lat: 50.425,
        lng: 11.505,
    },
    {
        lat: 50.415,
        lng: 11.515,
    },
    {
        lat: 50.415,
        lng: 11.53,
    },
    {
        lat: 50.4,
        lng: 11.535,
    },
    {
        lat: 50.42,
        lng: 11.565,
    },
    {
        lat: 50.425,
        lng: 11.59,
    },
    {
        lat: 50.41,
        lng: 11.62,
    },
    {
        lat: 50.41,
        lng: 11.65,
    },
    {
        lat: 50.415,
        lng: 11.69,
    },
    {
        lat: 50.425,
        lng: 11.705,
    },
    {
        lat: 50.42,
        lng: 11.725,
    },
    {
        lat: 50.435,
        lng: 11.745,
    },
    {
        lat: 50.44,
        lng: 11.8,
    },
    {
        lat: 50.425,
        lng: 11.815,
    },
    {
        lat: 50.42,
        lng: 11.855,
    },
    {
        lat: 50.435,
        lng: 11.875,
    },
    {
        lat: 50.445,
        lng: 11.94,
    },
    {
        lat: 50.41,
        lng: 11.98,
    },
    {
        lat: 50.405,
        lng: 12,
    },
    {
        lat: 50.37,
        lng: 12.005,
    },
    {
        lat: 50.36,
        lng: 12.04,
    },
    {
        lat: 50.35,
        lng: 12.05,
    },
    {
        lat: 50.355,
        lng: 12.09,
    },
    {
        lat: 50.345,
        lng: 12.11,
    },
    {
        lat: 50.335,
        lng: 12.11,
    },
    {
        lat: 50.32,
        lng: 12.145,
    },
    {
        lat: 50.3,
        lng: 12.145,
    },
    {
        lat: 50.285,
        lng: 12.16,
    },
    {
        lat: 50.255,
        lng: 12.15,
    },
    {
        lat: 50.255,
        lng: 12.16,
    },
    {
        lat: 50.22,
        lng: 12.195,
    },
    {
        lat: 50.22,
        lng: 12.205,
    },
    {
        lat: 50.175,
        lng: 12.235,
    },
    {
        lat: 50.16,
        lng: 12.235,
    },
    {
        lat: 50.13,
        lng: 12.215,
    },
    {
        lat: 50.125,
        lng: 12.22,
    },
    {
        lat: 50.115,
        lng: 12.26,
    },
    {
        lat: 50.08,
        lng: 12.295,
    },
    {
        lat: 50.075,
        lng: 12.325,
    },
    {
        lat: 50.06,
        lng: 12.335,
    },
    {
        lat: 50.06,
        lng: 12.35,
    },
    {
        lat: 50.035,
        lng: 12.385,
    },
    {
        lat: 50.035,
        lng: 12.41,
    },
    {
        lat: 50.02,
        lng: 12.425,
    },
    {
        lat: 50.015,
        lng: 12.47,
    },
    {
        lat: 50,
        lng: 12.485,
    },
    {
        lat: 50,
        lng: 12.5,
    },
    {
        lat: 49.98,
        lng: 12.52,
    },
    {
        lat: 49.95,
        lng: 12.51,
    },
    {
        lat: 49.945,
        lng: 12.55,
    },
    {
        lat: 49.935,
        lng: 12.565,
    },
    {
        lat: 49.895,
        lng: 12.57,
    },
    {
        lat: 49.875,
        lng: 12.555,
    },
    {
        lat: 49.87,
        lng: 12.54,
    },
    {
        lat: 49.82,
        lng: 12.51,
    },
    {
        lat: 49.82,
        lng: 12.495,
    },
    {
        lat: 49.805,
        lng: 12.49,
    },
    {
        lat: 49.78,
        lng: 12.495,
    },
    {
        lat: 49.765,
        lng: 12.48,
    },
    {
        lat: 49.755,
        lng: 12.435,
    },
    {
        lat: 49.745,
        lng: 12.435,
    },
    {
        lat: 49.72,
        lng: 12.455,
    },
    {
        lat: 49.715,
        lng: 12.49,
    },
    {
        lat: 49.705,
        lng: 12.5,
    },
    {
        lat: 49.71,
        lng: 12.515,
    },
    {
        lat: 49.705,
        lng: 12.535,
    },
    {
        lat: 49.675,
        lng: 12.55,
    },
    {
        lat: 49.645,
        lng: 12.545,
    },
    {
        lat: 49.64,
        lng: 12.57,
    },
    {
        lat: 49.63,
        lng: 12.58,
    },
    {
        lat: 49.56,
        lng: 12.6,
    },
    {
        lat: 49.55,
        lng: 12.61,
    },
    {
        lat: 49.55,
        lng: 12.65,
    },
    {
        lat: 49.53,
        lng: 12.665,
    },
    {
        lat: 49.5,
        lng: 12.66,
    },
    {
        lat: 49.445,
        lng: 12.68,
    },
    {
        lat: 49.445,
        lng: 12.715,
    },
    {
        lat: 49.43,
        lng: 12.73,
    },
    {
        lat: 49.42,
        lng: 12.76,
    },
    {
        lat: 49.4,
        lng: 12.78,
    },
    {
        lat: 49.385,
        lng: 12.78,
    },
    {
        lat: 49.37,
        lng: 12.8,
    },
    {
        lat: 49.36,
        lng: 12.8,
    },
    {
        lat: 49.365,
        lng: 12.835,
    },
    {
        lat: 49.36,
        lng: 12.865,
    },
    {
        lat: 49.37,
        lng: 12.875,
    },
    {
        lat: 49.365,
        lng: 12.95,
    },
    {
        lat: 49.355,
        lng: 12.98,
    },
    {
        lat: 49.325,
        lng: 13.02,
    },
    {
        lat: 49.325,
        lng: 13.035,
    },
    {
        lat: 49.31,
        lng: 13.05,
    },
    {
        lat: 49.285,
        lng: 13.05,
    },
    {
        lat: 49.28,
        lng: 13.07,
    },
    {
        lat: 49.265,
        lng: 13.075,
    },
    {
        lat: 49.265,
        lng: 13.095,
    },
    {
        lat: 49.24,
        lng: 13.11,
    },
    {
        lat: 49.24,
        lng: 13.12,
    },
    {
        lat: 49.225,
        lng: 13.135,
    },
    {
        lat: 49.21,
        lng: 13.14,
    },
    {
        lat: 49.18,
        lng: 13.195,
    },
    {
        lat: 49.15,
        lng: 13.195,
    },
    {
        lat: 49.135,
        lng: 13.225,
    },
    {
        lat: 49.14,
        lng: 13.295,
    },
    {
        lat: 49.065,
        lng: 13.415,
    },
    {
        lat: 48.995,
        lng: 13.43,
    },
    {
        lat: 48.985,
        lng: 13.445,
    },
    {
        lat: 48.985,
        lng: 13.46,
    },
    {
        lat: 48.97,
        lng: 13.485,
    },
    {
        lat: 48.99,
        lng: 13.5,
    },
    {
        lat: 48.995,
        lng: 13.525,
    },
    {
        lat: 48.99,
        lng: 13.59,
    },
    {
        lat: 48.975,
        lng: 13.61,
    },
    {
        lat: 48.965,
        lng: 13.61,
    },
    {
        lat: 48.965,
        lng: 13.645,
    },
    {
        lat: 48.93,
        lng: 13.655,
    },
    {
        lat: 48.9,
        lng: 13.685,
    },
    {
        lat: 48.905,
        lng: 13.72,
    },
    {
        lat: 48.9,
        lng: 13.755,
    },
    {
        lat: 48.855,
        lng: 13.775,
    },
    {
        lat: 48.845,
        lng: 13.81,
    },
    {
        lat: 48.825,
        lng: 13.815,
    },
    {
        lat: 48.805,
        lng: 13.835,
    },
    {
        lat: 48.79,
        lng: 13.835,
    },
    {
        lat: 48.79,
        lng: 13.85,
    },
    {
        lat: 48.78,
        lng: 13.86,
    },
    {
        lat: 48.76,
        lng: 13.86,
    },
    {
        lat: 48.745,
        lng: 13.85,
    },
    {
        lat: 48.745,
        lng: 13.84,
    },
    {
        lat: 48.725,
        lng: 13.835,
    },
    {
        lat: 48.715,
        lng: 13.855,
    },
    {
        lat: 48.685,
        lng: 13.855,
    },
    {
        lat: 48.675,
        lng: 13.84,
    },
    {
        lat: 48.61,
        lng: 13.845,
    },
    {
        lat: 48.595,
        lng: 13.825,
    },
    {
        lat: 48.56,
        lng: 13.82,
    },
    {
        lat: 48.535,
        lng: 13.77,
    },
    {
        lat: 48.525,
        lng: 13.77,
    },
    {
        lat: 48.495,
        lng: 13.74,
    },
    {
        lat: 48.495,
        lng: 13.705,
    },
    {
        lat: 48.51,
        lng: 13.685,
    },
    {
        lat: 48.52,
        lng: 13.645,
    },
    {
        lat: 48.535,
        lng: 13.64,
    },
    {
        lat: 48.535,
        lng: 13.615,
    },
    {
        lat: 48.545,
        lng: 13.605,
    },
    {
        lat: 48.54,
        lng: 13.565,
    },
    {
        lat: 48.565,
        lng: 13.525,
    },
    {
        lat: 48.545,
        lng: 13.5,
    },
    {
        lat: 48.535,
        lng: 13.47,
    },
    {
        lat: 48.51,
        lng: 13.48,
    },
    {
        lat: 48.46,
        lng: 13.45,
    },
    {
        lat: 48.445,
        lng: 13.46,
    },
    {
        lat: 48.425,
        lng: 13.46,
    },
    {
        lat: 48.4,
        lng: 13.44,
    },
    {
        lat: 48.37,
        lng: 13.435,
    },
    {
        lat: 48.35,
        lng: 13.415,
    },
    {
        lat: 48.34,
        lng: 13.38,
    },
    {
        lat: 48.3,
        lng: 13.335,
    },
    {
        lat: 48.3,
        lng: 13.32,
    },
    {
        lat: 48.275,
        lng: 13.27,
    },
    {
        lat: 48.275,
        lng: 13.175,
    },
    {
        lat: 48.26,
        lng: 13.145,
    },
    {
        lat: 48.26,
        lng: 13.085,
    },
    {
        lat: 48.245,
        lng: 13.065,
    },
    {
        lat: 48.24,
        lng: 13.025,
    },
    {
        lat: 48.215,
        lng: 13.005,
    },
    {
        lat: 48.19,
        lng: 12.97,
    },
    {
        lat: 48.185,
        lng: 12.88,
    },
    {
        lat: 48.15,
        lng: 12.86,
    },
    {
        lat: 48.13,
        lng: 12.83,
    },
    {
        lat: 48.13,
        lng: 12.815,
    },
    {
        lat: 48.105,
        lng: 12.8,
    },
    {
        lat: 48.1,
        lng: 12.77,
    },
    {
        lat: 48.085,
        lng: 12.775,
    },
    {
        lat: 48.05,
        lng: 12.84,
    },
    {
        lat: 48.02,
        lng: 12.875,
    },
    {
        lat: 47.98,
        lng: 12.885,
    },
    {
        lat: 47.98,
        lng: 12.91,
    },
    {
        lat: 47.965,
        lng: 12.945,
    },
    {
        lat: 47.95,
        lng: 12.96,
    },
    {
        lat: 47.935,
        lng: 12.96,
    },
    {
        lat: 47.915,
        lng: 12.985,
    },
    {
        lat: 47.905,
        lng: 12.985,
    },
    {
        lat: 47.855,
        lng: 13.025,
    },
    {
        lat: 47.835,
        lng: 13.025,
    },
    {
        lat: 47.775,
        lng: 12.965,
    },
    {
        lat: 47.755,
        lng: 12.965,
    },
    {
        lat: 47.73,
        lng: 12.95,
    },
    {
        lat: 47.73,
        lng: 12.99,
    },
    {
        lat: 47.745,
        lng: 13.005,
    },
    {
        lat: 47.735,
        lng: 13.05,
    },
    {
        lat: 47.695,
        lng: 13.1,
    },
    {
        lat: 47.67,
        lng: 13.1,
    },
    {
        lat: 47.655,
        lng: 13.115,
    },
    {
        lat: 47.63,
        lng: 13.12,
    },
    {
        lat: 47.6,
        lng: 13.09,
    },
    {
        lat: 47.575,
        lng: 13.09,
    },
    {
        lat: 47.565,
        lng: 13.075,
    },
    {
        lat: 47.55,
        lng: 13.075,
    },
    {
        lat: 47.535,
        lng: 13.06,
    },
    {
        lat: 47.49,
        lng: 13.07,
    },
    {
        lat: 47.47,
        lng: 13.055,
    },
    {
        lat: 47.47,
        lng: 13.04,
    },
    {
        lat: 47.445,
        lng: 13.015,
    },
    {
        lat: 47.46,
        lng: 12.94,
    },
    {
        lat: 47.485,
        lng: 12.885,
    },
    {
        lat: 47.505,
        lng: 12.865,
    },
    {
        lat: 47.51,
        lng: 12.845,
    },
    {
        lat: 47.525,
        lng: 12.835,
    },
    {
        lat: 47.525,
        lng: 12.81,
    },
    {
        lat: 47.54,
        lng: 12.78,
    },
    {
        lat: 47.565,
        lng: 12.76,
    },
    {
        lat: 47.59,
        lng: 12.76,
    },
    {
        lat: 47.605,
        lng: 12.775,
    },
    {
        lat: 47.615,
        lng: 12.775,
    },
    {
        lat: 47.62,
        lng: 12.76,
    },
    {
        lat: 47.66,
        lng: 12.73,
    },
    {
        lat: 47.655,
        lng: 12.725,
    },
    {
        lat: 47.66,
        lng: 12.67,
    },
    {
        lat: 47.65,
        lng: 12.66,
    },
    {
        lat: 47.655,
        lng: 12.615,
    },
    {
        lat: 47.615,
        lng: 12.59,
    },
    {
        lat: 47.61,
        lng: 12.575,
    },
    {
        lat: 47.615,
        lng: 12.535,
    },
    {
        lat: 47.605,
        lng: 12.52,
    },
    {
        lat: 47.605,
        lng: 12.49,
    },
    {
        lat: 47.625,
        lng: 12.475,
    },
    {
        lat: 47.635,
        lng: 12.45,
    },
    {
        lat: 47.665,
        lng: 12.42,
    },
    {
        lat: 47.675,
        lng: 12.42,
    },
    {
        lat: 47.665,
        lng: 12.385,
    },
    {
        lat: 47.675,
        lng: 12.31,
    },
    {
        lat: 47.67,
        lng: 12.285,
    },
    {
        lat: 47.66,
        lng: 12.275,
    },
    {
        lat: 47.66,
        lng: 12.245,
    },
    {
        lat: 47.69,
        lng: 12.22,
    },
    {
        lat: 47.69,
        lng: 12.205,
    },
    {
        lat: 47.68,
        lng: 12.195,
    },
    {
        lat: 47.65,
        lng: 12.22,
    },
    {
        lat: 47.62,
        lng: 12.23,
    },
    {
        lat: 47.595,
        lng: 12.225,
    },
    {
        lat: 47.585,
        lng: 12.21,
    },
    {
        lat: 47.58,
        lng: 12.17,
    },
    {
        lat: 47.59,
        lng: 12.16,
    },
    {
        lat: 47.585,
        lng: 12.12,
    },
    {
        lat: 47.595,
        lng: 12.07,
    },
    {
        lat: 47.59,
        lng: 12.015,
    },
    {
        lat: 47.6,
        lng: 12.005,
    },
    {
        lat: 47.6,
        lng: 11.99,
    },
    {
        lat: 47.585,
        lng: 11.87,
    },
    {
        lat: 47.57,
        lng: 11.865,
    },
    {
        lat: 47.56,
        lng: 11.85,
    },
    {
        lat: 47.57,
        lng: 11.79,
    },
    {
        lat: 47.57,
        lng: 11.7,
    },
    {
        lat: 47.56,
        lng: 11.62,
    },
    {
        lat: 47.55,
        lng: 11.61,
    },
    {
        lat: 47.52,
        lng: 11.61,
    },
    {
        lat: 47.495,
        lng: 11.58,
    },
    {
        lat: 47.485,
        lng: 11.52,
    },
    {
        lat: 47.49,
        lng: 11.435,
    },
    {
        lat: 47.485,
        lng: 11.425,
    },
    {
        lat: 47.455,
        lng: 11.44,
    },
    {
        lat: 47.435,
        lng: 11.44,
    },
    {
        lat: 47.425,
        lng: 11.43,
    },
    {
        lat: 47.43,
        lng: 11.35,
    },
    {
        lat: 47.41,
        lng: 11.31,
    },
    {
        lat: 47.39,
        lng: 11.305,
    },
    {
        lat: 47.385,
        lng: 11.295,
    },
    {
        lat: 47.375,
        lng: 11.24,
    },
    {
        lat: 47.375,
        lng: 11.215,
    },
    {
        lat: 47.385,
        lng: 11.205,
    },
    {
        lat: 47.41,
        lng: 11.205,
    },
    {
        lat: 47.4,
        lng: 11.155,
    },
    {
        lat: 47.375,
        lng: 11.125,
    },
    {
        lat: 47.375,
        lng: 10.975,
    },
    {
        lat: 47.395,
        lng: 10.95,
    },
    {
        lat: 47.435,
        lng: 10.95,
    },
    {
        lat: 47.45,
        lng: 10.92,
    },
    {
        lat: 47.465,
        lng: 10.91,
    },
    {
        lat: 47.46,
        lng: 10.865,
    },
    {
        lat: 47.475,
        lng: 10.85,
    },
    {
        lat: 47.51,
        lng: 10.85,
    },
    {
        lat: 47.495,
        lng: 10.765,
    },
    {
        lat: 47.51,
        lng: 10.745,
    },
    {
        lat: 47.52,
        lng: 10.745,
    },
    {
        lat: 47.52,
        lng: 10.705,
    },
    {
        lat: 47.54,
        lng: 10.67,
    },
    {
        lat: 47.545,
        lng: 10.615,
    },
    {
        lat: 47.545,
        lng: 10.6,
    },
    {
        lat: 47.525,
        lng: 10.595,
    },
    {
        lat: 47.515,
        lng: 10.58,
    },
    {
        lat: 47.515,
        lng: 10.51,
    },
    {
        lat: 47.53,
        lng: 10.465,
    },
    {
        lat: 47.505,
        lng: 10.46,
    },
    {
        lat: 47.5,
        lng: 10.475,
    },
    {
        lat: 47.48,
        lng: 10.49,
    },
    {
        lat: 47.42,
        lng: 10.495,
    },
    {
        lat: 47.4,
        lng: 10.455,
    },
    {
        lat: 47.37,
        lng: 10.455,
    },
    {
        lat: 47.36,
        lng: 10.445,
    },
    {
        lat: 47.365,
        lng: 10.425,
    },
    {
        lat: 47.36,
        lng: 10.41,
    },
    {
        lat: 47.345,
        lng: 10.405,
    },
    {
        lat: 47.335,
        lng: 10.385,
    },
    {
        lat: 47.32,
        lng: 10.37,
    },
    {
        lat: 47.31,
        lng: 10.37,
    },
    {
        lat: 47.285,
        lng: 10.34,
    },
    {
        lat: 47.285,
        lng: 10.315,
    },
    {
        lat: 47.25,
        lng: 10.24,
    },
    {
        lat: 47.255,
        lng: 10.225,
    },
    {
        lat: 47.25,
        lng: 10.165,
    },
    {
        lat: 47.28,
        lng: 10.15,
    },
    {
        lat: 47.3,
        lng: 10.155,
    },
    {
        lat: 47.315,
        lng: 10.17,
    },
    {
        lat: 47.315,
        lng: 10.18,
    },
    {
        lat: 47.335,
        lng: 10.18,
    },
    {
        lat: 47.365,
        lng: 10.2,
    },
    {
        lat: 47.365,
        lng: 10.19,
    },
    {
        lat: 47.35,
        lng: 10.175,
    },
    {
        lat: 47.345,
        lng: 10.155,
    },
    {
        lat: 47.35,
        lng: 10.12,
    },
    {
        lat: 47.335,
        lng: 10.11,
    },
    {
        lat: 47.335,
        lng: 10.09,
    },
    {
        lat: 47.39,
        lng: 10.065,
    },
    {
        lat: 47.39,
        lng: 10.055,
    },
    {
        lat: 47.4,
        lng: 10.05,
    },
    {
        lat: 47.42,
        lng: 10.05,
    },
    {
        lat: 47.435,
        lng: 10.065,
    },
    {
        lat: 47.455,
        lng: 10.035,
    },
    {
        lat: 47.465,
        lng: 10.035,
    },
    {
        lat: 47.46,
        lng: 10,
    },
    {
        lat: 47.475,
        lng: 9.975,
    },
    {
        lat: 47.495,
        lng: 9.97,
    },
    {
        lat: 47.515,
        lng: 9.945,
    },
    {
        lat: 47.51,
        lng: 9.91,
    },
    {
        lat: 47.525,
        lng: 9.895,
    },
    {
        lat: 47.51,
        lng: 9.885,
    },
    {
        lat: 47.51,
        lng: 9.86,
    },
    {
        lat: 47.525,
        lng: 9.835,
    },
    {
        lat: 47.525,
        lng: 9.815,
    },
    {
        lat: 47.54,
        lng: 9.795,
    },
    {
        lat: 47.575,
        lng: 9.8,
    },
    {
        lat: 47.575,
        lng: 9.785,
    },
    {
        lat: 47.555,
        lng: 9.765,
    },
    {
        lat: 47.515,
        lng: 9.745,
    },
    {
        lat: 47.515,
        lng: 9.55,
    },
    {
        lat: 47.53,
        lng: 9.53,
    },
    {
        lat: 47.54,
        lng: 9.53,
    },
    {
        lat: 47.605,
        lng: 9.595,
    },
    {
        lat: 47.605,
        lng: 9.615,
    },
    {
        lat: 47.625,
        lng: 9.63,
    },
    {
        lat: 47.63,
        lng: 9.65,
    },
    {
        lat: 47.625,
        lng: 9.715,
    },
    {
        lat: 47.635,
        lng: 9.725,
    },
    {
        lat: 47.635,
        lng: 9.755,
    },
    {
        lat: 47.65,
        lng: 9.775,
    },
    {
        lat: 47.665,
        lng: 9.78,
    },
    {
        lat: 47.67,
        lng: 9.81,
    },
    {
        lat: 47.69,
        lng: 9.82,
    },
    {
        lat: 47.7,
        lng: 9.845,
    },
    {
        lat: 47.695,
        lng: 9.885,
    },
    {
        lat: 47.68,
        lng: 9.9,
    },
    {
        lat: 47.675,
        lng: 9.93,
    },
    {
        lat: 47.675,
        lng: 9.96,
    },
    {
        lat: 47.7,
        lng: 9.985,
    },
    {
        lat: 47.71,
        lng: 10.025,
    },
    {
        lat: 47.7,
        lng: 10.045,
    },
    {
        lat: 47.7,
        lng: 10.07,
    },
    {
        lat: 47.69,
        lng: 10.075,
    },
    {
        lat: 47.695,
        lng: 10.085,
    },
    {
        lat: 47.69,
        lng: 10.11,
    },
    {
        lat: 47.7,
        lng: 10.11,
    },
    {
        lat: 47.71,
        lng: 10.095,
    },
    {
        lat: 47.745,
        lng: 10.095,
    },
    {
        lat: 47.75,
        lng: 10.075,
    },
    {
        lat: 47.765,
        lng: 10.065,
    },
    {
        lat: 47.775,
        lng: 10.045,
    },
    {
        lat: 47.795,
        lng: 10.045,
    },
    {
        lat: 47.825,
        lng: 10.085,
    },
    {
        lat: 47.865,
        lng: 10.055,
    },
    {
        lat: 47.91,
        lng: 10.085,
    },
    {
        lat: 47.93,
        lng: 10.085,
    },
    {
        lat: 47.945,
        lng: 10.065,
    },
    {
        lat: 47.97,
        lng: 10.065,
    },
    {
        lat: 47.99,
        lng: 10.08,
    },
    {
        lat: 48,
        lng: 10.1,
    },
    {
        lat: 48.015,
        lng: 10.1,
    },
    {
        lat: 48.02,
        lng: 10.11,
    },
    {
        lat: 48.045,
        lng: 10.11,
    },
    {
        lat: 48.05,
        lng: 10.12,
    },
    {
        lat: 48.07,
        lng: 10.115,
    },
    {
        lat: 48.09,
        lng: 10.12,
    },
    {
        lat: 48.105,
        lng: 10.11,
    },
    {
        lat: 48.11,
        lng: 10.095,
    },
    {
        lat: 48.15,
        lng: 10.075,
    },
    {
        lat: 48.195,
        lng: 10.065,
    },
    {
        lat: 48.24,
        lng: 10.04,
    },
    {
        lat: 48.275,
        lng: 10.04,
    },
    {
        lat: 48.345,
        lng: 9.975,
    },
    {
        lat: 48.345,
        lng: 9.965,
    },
    {
        lat: 48.36,
        lng: 9.95,
    },
    {
        lat: 48.375,
        lng: 9.945,
    },
    {
        lat: 48.395,
        lng: 9.955,
    },
    {
        lat: 48.415,
        lng: 9.995,
    },
    {
        lat: 48.435,
        lng: 10.01,
    },
    {
        lat: 48.465,
        lng: 10.01,
    },
    {
        lat: 48.48,
        lng: 10.03,
    },
    {
        lat: 48.475,
        lng: 10.05,
    },
    {
        lat: 48.48,
        lng: 10.075,
    },
    {
        lat: 48.5,
        lng: 10.105,
    },
    {
        lat: 48.495,
        lng: 10.125,
    },
    {
        lat: 48.475,
        lng: 10.14,
    },
    {
        lat: 48.475,
        lng: 10.15,
    },
    {
        lat: 48.49,
        lng: 10.165,
    },
    {
        lat: 48.505,
        lng: 10.205,
    },
    {
        lat: 48.52,
        lng: 10.21,
    },
    {
        lat: 48.53,
        lng: 10.225,
    },
    {
        lat: 48.54,
        lng: 10.25,
    },
    {
        lat: 48.535,
        lng: 10.28,
    },
    {
        lat: 48.55,
        lng: 10.28,
    },
    {
        lat: 48.56,
        lng: 10.29,
    },
    {
        lat: 48.57,
        lng: 10.29,
    },
    {
        lat: 48.58,
        lng: 10.275,
    },
    {
        lat: 48.615,
        lng: 10.28,
    },
    {
        lat: 48.645,
        lng: 10.24,
    },
    {
        lat: 48.685,
        lng: 10.235,
    },
    {
        lat: 48.7,
        lng: 10.25,
    },
    {
        lat: 48.715,
        lng: 10.25,
    },
    {
        lat: 48.725,
        lng: 10.265,
    },
    {
        lat: 48.72,
        lng: 10.295,
    },
    {
        lat: 48.71,
        lng: 10.3,
    },
    {
        lat: 48.71,
        lng: 10.34,
    },
    {
        lat: 48.685,
        lng: 10.365,
    },
    {
        lat: 48.72,
        lng: 10.4,
    },
    {
        lat: 48.72,
        lng: 10.42,
    },
    {
        lat: 48.74,
        lng: 10.395,
    },
    {
        lat: 48.755,
        lng: 10.4,
    },
    {
        lat: 48.77,
        lng: 10.39,
    },
    {
        lat: 48.815,
        lng: 10.405,
    },
    {
        lat: 48.82,
        lng: 10.415,
    },
    {
        lat: 48.845,
        lng: 10.405,
    },
    {
        lat: 48.865,
        lng: 10.42,
    },
    {
        lat: 48.865,
        lng: 10.43,
    },
    {
        lat: 48.88,
        lng: 10.425,
    },
    {
        lat: 48.9,
        lng: 10.4,
    },
    {
        lat: 48.92,
        lng: 10.405,
    },
    {
        lat: 48.93,
        lng: 10.42,
    },
    {
        lat: 48.955,
        lng: 10.385,
    },
    {
        lat: 48.97,
        lng: 10.385,
    },
    {
        lat: 48.97,
        lng: 10.37,
    },
    {
        lat: 48.985,
        lng: 10.36,
    },
    {
        lat: 48.985,
        lng: 10.345,
    },
    {
        lat: 49.005,
        lng: 10.33,
    },
    {
        lat: 49.02,
        lng: 10.28,
    },
    {
        lat: 49.02,
        lng: 10.24,
    },
    {
        lat: 49.035,
        lng: 10.23,
    },
    {
        lat: 49.055,
        lng: 10.23,
    },
    {
        lat: 49.065,
        lng: 10.215,
    },
    {
        lat: 49.075,
        lng: 10.215,
    },
    {
        lat: 49.08,
        lng: 10.19,
    },
    {
        lat: 49.09,
        lng: 10.185,
    },
    {
        lat: 49.11,
        lng: 10.185,
    },
    {
        lat: 49.135,
        lng: 10.21,
    },
    {
        lat: 49.135,
        lng: 10.19,
    },
    {
        lat: 49.155,
        lng: 10.175,
    },
    {
        lat: 49.16,
        lng: 10.155,
    },
    {
        lat: 49.175,
        lng: 10.14,
    },
    {
        lat: 49.175,
        lng: 10.12,
    },
    {
        lat: 49.19,
        lng: 10.105,
    },
    {
        lat: 49.235,
        lng: 10.105,
    },
    {
        lat: 49.25,
        lng: 10.09,
    },
    {
        lat: 49.265,
        lng: 10.09,
    },
    {
        lat: 49.285,
        lng: 10.1,
    },
    {
        lat: 49.295,
        lng: 10.115,
    },
    {
        lat: 49.31,
        lng: 10.11,
    },
    {
        lat: 49.31,
        lng: 10.1,
    },
    {
        lat: 49.33,
        lng: 10.085,
    },
    {
        lat: 49.38,
        lng: 10.085,
    },
    {
        lat: 49.405,
        lng: 10.105,
    },
    {
        lat: 49.41,
        lng: 10.12,
    },
    {
        lat: 49.42,
        lng: 10.12,
    },
    {
        lat: 49.42,
        lng: 10.1,
    },
    {
        lat: 49.44,
        lng: 10.075,
    },
    {
        lat: 49.46,
        lng: 10.075,
    },
    {
        lat: 49.47,
        lng: 10.085,
    },
    {
        lat: 49.495,
        lng: 10.075,
    },
    {
        lat: 49.485,
        lng: 10.04,
    },
    {
        lat: 49.465,
        lng: 10.03,
    },
    {
        lat: 49.46,
        lng: 9.94,
    },
    {
        lat: 49.465,
        lng: 9.915,
    },
    {
        lat: 49.485,
        lng: 9.895,
    },
    {
        lat: 49.54,
        lng: 9.9,
    },
    {
        lat: 49.545,
        lng: 9.88,
    },
    {
        lat: 49.525,
        lng: 9.865,
    },
    {
        lat: 49.525,
        lng: 9.84,
    },
    {
        lat: 49.535,
        lng: 9.805,
    },
    {
        lat: 49.55,
        lng: 9.79,
    },
    {
        lat: 49.565,
        lng: 9.79,
    },
    {
        lat: 49.58,
        lng: 9.82,
    },
    {
        lat: 49.6,
        lng: 9.82,
    },
    {
        lat: 49.615,
        lng: 9.84,
    },
    {
        lat: 49.625,
        lng: 9.84,
    },
    {
        lat: 49.635,
        lng: 9.815,
    },
    {
        lat: 49.66,
        lng: 9.8,
    },
    {
        lat: 49.69,
        lng: 9.81,
    },
    {
        lat: 49.7,
        lng: 9.795,
    },
    {
        lat: 49.7,
        lng: 9.775,
    },
    {
        lat: 49.685,
        lng: 9.77,
    },
    {
        lat: 49.67,
        lng: 9.75,
    },
    {
        lat: 49.67,
        lng: 9.715,
    },
    {
        lat: 49.685,
        lng: 9.71,
    },
    {
        lat: 49.695,
        lng: 9.695,
    },
    {
        lat: 49.675,
        lng: 9.685,
    },
    {
        lat: 49.665,
        lng: 9.65,
    },
    {
        lat: 49.68,
        lng: 9.615,
    },
    {
        lat: 49.69,
        lng: 9.615,
    },
    {
        lat: 49.695,
        lng: 9.605,
    },
    {
        lat: 49.735,
        lng: 9.605,
    },
    {
        lat: 49.75,
        lng: 9.62,
    },
    {
        lat: 49.765,
        lng: 9.62,
    },
    {
        lat: 49.76,
        lng: 9.59,
    },
    {
        lat: 49.745,
        lng: 9.59,
    },
    {
        lat: 49.725,
        lng: 9.575,
    },
    {
        lat: 49.725,
        lng: 9.55,
    },
    {
        lat: 49.745,
        lng: 9.535,
    },
    {
        lat: 49.74,
        lng: 9.51,
    },
    {
        lat: 49.75,
        lng: 9.505,
    },
    {
        lat: 49.75,
        lng: 9.495,
    },
    {
        lat: 49.765,
        lng: 9.49,
    },
    {
        lat: 49.75,
        lng: 9.47,
    },
    {
        lat: 49.75,
        lng: 9.445,
    },
    {
        lat: 49.765,
        lng: 9.42,
    },
    {
        lat: 49.75,
        lng: 9.4,
    },
    {
        lat: 49.75,
        lng: 9.41,
    },
    {
        lat: 49.72,
        lng: 9.44,
    },
    {
        lat: 49.65,
        lng: 9.44,
    },
    {
        lat: 49.625,
        lng: 9.415,
    },
    {
        lat: 49.625,
        lng: 9.37,
    },
    {
        lat: 49.635,
        lng: 9.365,
    },
    {
        lat: 49.625,
        lng: 9.355,
    },
    {
        lat: 49.63,
        lng: 9.305,
    },
    {
        lat: 49.61,
        lng: 9.305,
    },
    {
        lat: 49.595,
        lng: 9.295,
    },
    {
        lat: 49.595,
        lng: 9.285,
    },
    {
        lat: 49.57,
        lng: 9.265,
    },
    {
        lat: 49.555,
        lng: 9.22,
    },
    {
        lat: 49.56,
        lng: 9.155,
    },
    {
        lat: 49.555,
        lng: 9.105,
    },
    {
        lat: 49.56,
        lng: 9.09,
    },
    {
        lat: 49.58,
        lng: 9.075,
    },
    {
        lat: 49.585,
        lng: 9.055,
    },
    {
        lat: 49.595,
        lng: 9.045,
    },
    {
        lat: 49.625,
        lng: 9.045,
    },
    {
        lat: 49.64,
        lng: 9.055,
    },
    {
        lat: 49.65,
        lng: 9.075,
    },
    {
        lat: 49.7,
        lng: 9.07,
    },
    {
        lat: 49.715,
        lng: 9.085,
    },
    {
        lat: 49.715,
        lng: 9.1,
    },
    {
        lat: 49.73,
        lng: 9.105,
    },
    {
        lat: 49.735,
        lng: 9.115,
    },
    {
        lat: 49.745,
        lng: 9.09,
    },
    {
        lat: 49.77,
        lng: 9.09,
    },
    {
        lat: 49.775,
        lng: 9.075,
    },
    {
        lat: 49.815,
        lng: 9.06,
    },
    {
        lat: 49.82,
        lng: 9.03,
    },
    {
        lat: 49.84,
        lng: 9.015,
    },
    {
        lat: 49.895,
        lng: 9.015,
    },
    {
        lat: 49.9,
        lng: 9.005,
    },
    {
        lat: 49.93,
        lng: 9.01,
    },
    {
        lat: 49.935,
        lng: 9,
    },
    {
        lat: 49.96,
        lng: 9.005,
    },
    {
        lat: 49.98,
        lng: 8.995,
    },
    {
        lat: 50,
        lng: 8.995,
    },
    {
        lat: 50.01,
        lng: 9.01,
    },
    {
        lat: 50.025,
        lng: 9.01,
    },
    {
        lat: 50.02,
        lng: 8.98,
    },
    {
        lat: 50.035,
        lng: 8.96,
    },
    {
        lat: 50.055,
        lng: 8.955,
    },
    {
        lat: 50.07,
        lng: 8.97,
    },
];
